import api from "utils/api";
import { makeRandomNickname } from "utils/util";

const USER_API_BASE_PATH = process.env.REACT_APP_USER_API_BASE_PATH;
const APP_API_URL = process.env.REACT_APP_API_URL;

// 로그인
export const postLogin = async (id, password) => {
    try {
        const res = await api.post("/buccl_user/auth/", {
            user_id: id,
            password: password,
        });
        return res.data;
    } catch (err) {
        return null;
    }
};

//인증번호 발송
export const postSendVerificationCode = async (phone) => {
    const res = await api.post("/buccl_user/api/v1/auth-message/", {
        hp: phone,
    });
    return res.data;
};

//인증번호 확인
export const postCheckVerificationCode = async (phone, code) => {
    const res = await api.post("/buccl_user/api/v1/auth-check/", {
        hp: phone,
        auth: code,
    });
    return res.data;
};

// 회원가입
export const postSignup = async (formData, policyAgree) => {
    const nickname = makeRandomNickname();
    const res = await api.post("/buccl_user/register/", {
        user_id: formData.user_id, //프론트단에서 이메일 형태만 수용
        password: formData.password,
        name: formData.name,
        user_email: formData.user_id,
        hp: formData.hp,
        level: 0,
        auth: 1,
        ...(formData.gender && { user_gender: formData.gender }),
        ...(formData.birthDate && { user_birthday: formData.birthDate }),
        terms_accepted: policyAgree.termsAccepted,
        age_confirmed: policyAgree.ageConfirmed,
        privacy_accepted: policyAgree.privacyAccepted,
        nickname: nickname,
    });
    return res.data;
};

// 아이디/비밀번호 찾기 > 인증번호 요청
export const postVerificationCode = async (tab, params) => {
    try {
        const res = await api.post(`/buccl_user/${tab}/request/`, params);
        return res.data;
    } catch (err) {
        const message = Object.values(err.response.data).flat().join(", ");
        return {
            message: message,
        };
    }
};

// 아이디 찾기 전체 프로세스 (OTP 검증 + 완료)
export const findUserId = async (name, phone, verificationCode) => {
    try {
        const verifyResult = await api.post(
            `/buccl_user/find-user-id/verify/`,
            {
                name: name,
                hp: phone,
                otp: verificationCode,
            }
        );

        if (verifyResult.status === 200) {
            const completeResult = await api.post(
                `/buccl_user/find-user-id/complete/`,
                { hp: phone }
            );
            return completeResult.data;
        } else {
            return {
                message: Object.values(verifyResult.data).flat().join(", "),
            };
        }
    } catch (err) {
        return {
            message: Object.values(err.response.data).flat().join(", "),
        };
    }
};

export const postPasswordVerify = async (id, phone, verificationCode) => {
    try {
        const res = await api.post(`/buccl_user/password_reset/verify/`, {
            user_id: id,
            hp: phone,
            otp: verificationCode,
        });
        return res.data;
    } catch (err) {
        return {
            message: Object.values(err.response.data).flat().join(", "),
        };
    }
};

export const postPasswordChange = async (hp, new_password) => {
    try {
        const res = await api.post(`/buccl_user/password_reset/complete/`, {
            hp: hp,
            new_password: new_password,
        });
        return res.data;
    } catch (err) {
        return {
            message: Object.values(err.response.data).flat().join(", "),
        };
    }
};

// 회원 정보 수정
export const updateUserData = async (params) => {
    const res = await api.patch(`/buccl_user/user/update/`, params);
    return res.data;
};

//회원 정보 조회
export const getUserInfo = async (userId) => {
    try {
        const res = await api.get(`${USER_API_BASE_PATH}/user-info/${userId}`);
        return res.data;
    } catch (err) {
        console.error("사용자 정보 불러오기 오류:", err);
    }
};

// 토큰 기반 본인 정보 조회 — 로그인 응답과 동일 shape(public_id 포함).
// user-info/{user_id} 라우트는 int pk/uuid만 받아 이메일 user_id로는 404 (BE#506).
export const getSessionUserInfo = async () => {
    try {
        const res = await api.get("/buccl_user/auth/");
        return res.data;
    } catch (err) {
        console.error("세션 사용자 정보 조회 오류:", err);
    }
};


//회원 소속 브랜드 조회
export const getMyBrand = async () => {
  try {
      const res = await api.get(`${USER_API_BASE_PATH}/me/home-brand/`);
      return res.data;
  } catch (err) {
      console.error("사용자 정보 불러오기 오류:", err);
  }
};

//활성 브랜드 목록 조회
export const getBrandList = async () => {
    try {
        const res = await api.get(`${USER_API_BASE_PATH}/brands/`);
        return res.data;
    } catch (err) {
        console.error("브랜드 목록 불러오기 오류:", err);
        return [];
    }
};

//회원 소속 브랜드(home_brand) 변경
export const updateHomeBrand = async (homeBrandId) => {
    const res = await api.patch(`${USER_API_BASE_PATH}/me/home-brand/`, {
        home_brand_id: homeBrandId,
    });
    return res.data;
};

// 통합 프로필 v2 조회 (ADR-016)
// 진입 경로(커뮤니티/강습/강사)에 상관없이 동일한 응답 shape 사용
export const getProfileV2 = async (userId) => {
    try {
        const res = await api.get(
            `${APP_API_URL}/buccl_user/api/v2/profiles/${encodeURIComponent(userId)}/`
        );
        return res.data;
    } catch (err) {
        console.error("통합 프로필 조회 오류:", err);
        return null;
    }
};

// 유저 주소 목록 조회
export const getUserAddressList = async () => {
    try {
        const res = await api.get(
            `${APP_API_URL}/buccl_user/api/v1/addresses/`
        );
        return res.data;
    } catch (err) {}
};

export const createUserAddressList = async (params) => {
    try {
        const res = await api.post(
            `${APP_API_URL}/buccl_user/api/v1/addresses/`,
            params
        );
        return res.data;
    } catch (err) {}
};

export const updateUserAddressList = async (id, params) => {
    try {
        const res = await api.patch(
            `/buccl_user/api/v1/addresses/${id}/`,
            params
        );
        return res.data;
    } catch (err) {}
};

export const deleteUserAddressList = async (id) => {
    try {
        const res = await api.delete(
            `${APP_API_URL}/buccl_user/api/v1/addresses/${id}/`
        );
        return res.data;
    } catch (err) {}
};

// API 경로 상수 정의
const LESSONS_API_PATH = "/buccl_lessons/api/v1";

//내 예약 내역 조회
export const getMySchedule = async () => {
    try {
        const res = await api.get(`${LESSONS_API_PATH}/my-reservations/`);
        return res.data;
    } catch (err) {
        console.error("사용자 정보 불러오기 오류:", err);
    }
};

//보유 이용권 조회
export const getMyTickets = async () => {
    try {
        const res = await api.get(`${LESSONS_API_PATH}/tickets/`);
        return res.data;
    } catch (err) {
        console.error("사용자 정보 불러오기 오류:", err);
    }
};

//연습반 이용권 조회
export const getPracticeTickets = async () => {
    try {
        const res = await api.get(`${LESSONS_API_PATH}/practice-tickets/`);
        return res.data;
    } catch (err) {
        console.error("연습반 이용권 조회 오류:", err);
        return [];
    }
};

//자격증 조회
export const getLicenseList = async () => {
    try {
        const res = await api.get(`/buccl_user/api/v1/certificates/`);
        return res.data;
    } catch (err) {
        return err;
    }
};

//자격증 업로드
export const submitLicenseImg = async (formData) => {
    try {
        const res = await api.post(
            `/buccl_user/api/v1/certificates/upload/`,
            formData
        );
        return res;
    } catch (err) {
        return err;
    }
};

// 프로필 이미지 업로드 (HEIC 등 이미지 포맷 변환은 서버에서 처리)
export const uploadProfileImage = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const res = await api.post("/buccl_user/api/v1/profile-image/", formData);
    return res.data;
};

// 프로필 이미지 삭제
export const deleteProfileImage = async () => {
    const res = await api.delete("/buccl_user/api/v1/profile-image/");
    return res.data;
};

//회원탈퇴
export const withdrawUser = async () => {
    try {
        const res = await api.post(`/buccl_user/api/v1/withdrawal/`);
        return res.data;
    } catch (err) {
        return err;
    }
};

// 디바이스 등록
export const registerDevice = async (payload) => {
    const res = await api.post(`/buccl_user/api/v1/notifications/register-device/`, payload);
    return res.data;
};

// 알림 목록 조회
export const getNotifications = async (deviceId) => {
    const params = deviceId ? { id: deviceId } : {};
    const res = await api.get(`/buccl_user/api/v1/notifications/`, { params });
    return res.data;
};

// 특정 알림 읽음 처리
export const markNotificationAsRead = async (notificationId) => {
    const res = await api.post(`/buccl_user/api/v1/notifications/${notificationId}/mark_read/`);
    return res.data;
};

// 모든 알림 읽음 처리 (백엔드에서 request.user로 사용자 식별)
export const markAllNotificationsAsRead = async () => {
    const res = await api.post(`/buccl_user/api/v1/notifications/mark_all_read/`);
    return res.data;
};

// 알림 inline 액션 POST 처리
// BE는 actions[*].api에 "/server/..." 절대 경로를 내려주는데
// axios baseURL이 이미 .../server라 /server 접두를 제거해서 중복 방지.
export const postNotificationAction = async (rawUrl) => {
    const url = rawUrl.replace(/^\/server/, "");
    const res = await api.post(url);
    return res.data;
};

// 알림 설정 조회
export const getNotificationSettings = async () => {
    const res = await api.get(`/buccl_user/api/v1/notifications/settings/`);
    return res.data;
};

// 알림 설정 수정 (예: { enable_push: true })
export const updateNotificationSettings = async (payload) => {
    const res = await api.put(`/buccl_user/api/v1/notifications/settings/`, payload);
    return res.data;
};

// 읽지 않은 알림 수 조회
export const getUnreadCount = async () => {
    const res = await api.get(`/buccl_user/api/v1/notifications/unread-count/`);
    return res.data;
};

// 회원 검색 (동행인 추가용)
export const searchUsers = async (query) => {
    try {
        const res = await api.get(`/buccl_user/api/v1/users/search/`, {
            params: { q: query },
        });
        return res.data;
    } catch (err) {
        console.error("회원 검색 오류:", err);
        return { data: [], count: 0 };
    }
};
